import { useWindowDimensions, View } from 'react-native'
import { useMaxWindowDimensions, useRWD } from '@ui/theme/useRWD'

import Point from './Point'
import { PointsProps } from './types'

export default function Points({ points }: PointsProps) {
  const { width: windowWidth, height: windowHeight } = useWindowDimensions()
  const { width: screenWidth, height: screenHeight } = useMaxWindowDimensions()

  return (
    <View
      className="fixed border border-red-500"
      style={{
        width: screenWidth,
        height: screenHeight,
        top: (windowHeight - screenHeight) / 2,
        bottom: (windowHeight - screenHeight) / 2,
        left: (windowWidth - screenWidth) / 2,
        right: (windowWidth - screenWidth) / 2,
      }}
    >
      {points.map(({ x, y, ...point }, index) => (
        <View
          key={`${index}:${x}x${y}`}
          style={{ position: 'absolute', top: y, left: x }}
        >
          <Point {...point} />
        </View>
      ))}
    </View>
  )
}
